/* esm.sh - rxjs@7.8.2/dist/esm/internal/util/mapOneOrManyArgs */
import{map as t}from"rxjs/dist/esm/internal/operators/map";var{isArray:o}=Array;function p(n,r){return o(r)?n(...r):n(r)}function c(n){return t(r=>p(n,r))}export{c as mapOneOrManyArgs};
//# sourceMappingURL=mapOneOrManyArgs.mjs.map